import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft, ScrollText } from "lucide-react";

export default function WisdomStory() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [story, setStory] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/wisdom-stories/${slug}`).then((r) => setStory(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="max-w-2xl mx-auto px-6 py-12 text-muted-foreground">Hikaye bulunamadı.</div>;
  if (!story) return <div className="max-w-2xl mx-auto px-6 py-12 text-muted-foreground">Yükleniyor...</div>;

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8" data-testid="wisdom-story-page">
      <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-sm text-muted-foreground hover:text-terra mb-6"><ArrowLeft size={16} /> Geri</button>
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-gold flex items-center gap-1"><ScrollText size={14} /> Bilgelik Hikayesi</p>
      <h1 className="font-serif text-4xl sm:text-5xl text-ink tracking-tight mt-2">{story.baslik}</h1>
      <article className="mt-6 space-y-4">
        {story.paragraflar?.map((p, i) => (
          <p key={i} className="text-lg text-ink-2 leading-relaxed font-serif">{p}</p>
        ))}
      </article>
      {story.kaynak_url && (
        <p className="text-xs text-muted-foreground mt-8 pt-4 border-t border-line">
          Kaynak: <a href={story.kaynak_url} target="_blank" rel="noreferrer" className="text-terra hover:underline">bilgelikhikayeleri.com</a>
        </p>
      )}
    </div>
  );
}
